import Vue from 'vue'
import App from '@/App.vue'
import '@/registerServiceWorker'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'

// import filters from '@/helpers/filters'

import { auth } from '@/firebase'
import { AppInfo } from '@/types/info'

// import VueApexCharts from "vue-apexcharts";

import JLoader from '@/ui/controls/JLoader.vue'

Vue.prototype.$auth = auth
Vue.prototype.$app = {
  name: 'Green Thumb',
  version: process.env.VUE_APP_VERSION,
  env: process.env.NODE_ENV || 'unknown',
  isDev: process.env.NODE_ENV === 'development',
} as AppInfo

Vue.component('JLoader', JLoader)

// Vue.use(VueApexCharts);
// Vue.component("apexchart", VueApexCharts);

// init filters
// Object.entries(filters).forEach(([key, filter]) => Vue.filter(key, filter))

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
